import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "@/data/content";

const EASE = [0.76, 0, 0.24, 1];

const PHOTOS = [
  { src: IMAGES.heroNight, label: "Guincho plataforma", span: "sm:col-span-2 sm:row-span-2" },
  { src: IMAGES.suvDay, label: "Transporte de SUV", span: "" },
  { src: IMAGES.rampReady, label: "Plataforma pronta", span: "" },
  { src: IMAGES.pickupStreet, label: "Remoção urbana", span: "sm:col-span-2" },
];

export const Gallery = () => {
  return (
    <section id="galeria" data-testid="gallery-section" className="border-y border-white/10 bg-[#0d0d0d] py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <span className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
            / 04 — Galeria
          </span>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-6xl">
            Nossos Atendimentos
          </h2>
        </Reveal>

        <div className="mt-12 grid auto-rows-[220px] grid-cols-1 gap-3 sm:grid-cols-3 sm:auto-rows-[240px]">
          {PHOTOS.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: EASE }}
              className={`group relative overflow-hidden border border-white/10 bg-[#1A1A1A] ${p.span}`}
            >
              <img
                src={p.src}
                alt={p.label}
                className="h-full w-full object-cover grayscale-[0.2] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-100" />
              <div className="absolute bottom-0 left-0 p-5">
                <span className="font-mono-t text-xs uppercase tracking-widest text-white">
                  {p.label}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
